import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, Input } from '@angular/core';
import Viewer from 'viewerjs';
@Component({
  selector: 'app-s-img-viewer',
  templateUrl: './s-img-viewer.component.html',
  styleUrls: ['./s-img-viewer.component.less']
})
export class SImgViewerComponent implements OnInit, OnChanges {
  // @Input() title = '预览';
  @ViewChild('imgWrap') imgWrap;
  @Input() src;
  constructor(
  ) { }
  isVisible = false;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }
  init() {
    this.isVisible = true;
    const viewer = new Viewer(this.imgWrap.nativeElement, {
      navbar: false
    });
    viewer.view(0);
  }
}
